import { ErrorState } from './error-state';

type FullPageErrorProps = { onRetry?: () => void; title?: string; message?: string };

export function FullPageError({ onRetry, title, message }: FullPageErrorProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-5 py-12">
      <div className="w-full max-w-95">
        <ErrorState headingLevel="h1" onRetry={onRetry} title={title} message={message} />
      </div>
    </main>
  );
}
